<template>
  <div class="row mx-2">
    <div class="col-12 border-top border-light-blue border-1">
    </div>
  </div>
  <div class="podcast-list col-lg-7 col-xl-8 col-xxl-9 px-2 px-lg-0">
    <div class="d-flex align-items-lg-center border-bottom border-light-blue border-1 mb-3 mb-lg-0 py-lg-3">
      <i class="fa-solid fa-microphone podcast-title-icon"></i><span class="h2 ms-3">All Podcasts</span>
    </div>
    <div class="border-bottom border-light border-1" v-for="(podcast, index) in podcastsLoaded">
      <podcast-card :podcast="podcast" />
    </div>
    <div class="d-flex">
      <button class="btn btn-outline-primary" @click="loadMore" v-if="podcasts.length > length">Load More</button>
    </div>
  </div>
</template>
<script>
  import PodcastCard from './PodcastCard';

  export default {
    name: 'PodcastList',
    data() {
      return {
        length: 8,
      };
    },
    props: {
      podcasts: {
        type: Array,
        required: true,
      },
      step: {
        type: Number,
        required: true,
        default: 15,
      }
    },
    components: {
      PodcastCard
    },
    methods: {
      loadMore(event) {
        if (event) event.currentTarget.blur();
        if (this.length > this.podcasts.length) return;
        this.length = this.length + this.step;
      },
    },
    computed: {
      podcastsLoaded() {
        console.log(this.podcasts.length + " > " + this.length);
        return this.podcasts.sort(function (a, b) {
          return new Date(b.PublishedUtc) - new Date(a.PublishedUtc);
        }).slice(0, this.length);
      },
    },
    setup(props) {
    },
  };
</script>
